import React, {useState, useCallback, useRef} from 'react';
import styled from 'styled-components';
import axios from 'axios';


// import {BITTERSWEET, OzContainer, OzBreadcrumbs, OzCard, Button, OzRow, Col, Input, Select} from '@ozwol/webui';

import Container from '../../common/components/Container';
import Card from '../../common/components/Card';
import Button from '../../common/components/Button';

import DatabaseService from '../../services/DatabaseService';

const Text = styled.div.withConfig({displayName:'-Text'})`
  font-size: 14px;
`;
const ErrorMessage = styled.div.withConfig({displayName:'-ErrorMessage'})`
  height: 30px;
  color: red;
`;

const Hide = styled.div.withConfig({displayName:'-Hide'})`
display: none;
`;


const RapportiNew = ({
  selected,
  type,
  fnSuccess,
  fnCancel
}) => {

  const [disabled] = useState(false);
  const [errorMessage] = useState(false);

  
  /** @type {[File, (f: File) => void]} */
  const [file, setFile] = useState(null);
  const formFileUpload = useRef();

  const addItem = useCallback(() => {
    if (file !== null){
      DatabaseService.loadRdp(selected,type,file.name).then((response) => {
        let formData = new FormData();
        Object.keys(response.fields).forEach((key) => 
          formData.append(key, response.fields[key])
        )

        fetch(response.url,
          {
            body: file,
            headers: {
              'Content-type': 'application/pdf',
              ...response.fields
            },
            method: 'put',
          }
        ).finally(fnSuccess)
      });

      
  }
  }, [file, fnSuccess, selected,type]);

  return (
    <Container size="medium">
      {/* {form ?  */}
        <form method="post" encType="multipart/form-data">
          {/* {Object.keys(form.fields).map((key) => 
            <input key={key} name={key} value={form.fields[key]} type="hidden" />
          )} */}
          
          

          <Card
            footerLeft={<Button onClick={() => fnCancel()}>Indietro</Button>}
            footerRight={<Button  onClick={disabled ? () => {} : () => addItem()} variant={disabled ? "disabled" : "default"} disabled={disabled}>Salva</Button>}
          >
            <Text>
              Caricamento <b>{type==="t" ? "RDP T" : "RDP E"}</b> su codici: <b>{selected.join(", ")}</b>
            </Text>

            <br/>
            <Button onClick={() => formFileUpload.current.click()}>Carica file</Button>
            <br/><br/>
            {file ? 
              "File caricato: "+file.name
            : null}

                        
            <Hide>
              <input ref={formFileUpload}  width="100%" type="file" name="file" accept=".pdf" onChange={(e) => setFile(e.target.files[0])} />
            </Hide>

            <ErrorMessage>
              <br/>{errorMessage}<br/>
            </ErrorMessage>
          </Card>
        </form>
      {/* : null} */}
    </Container>
  )
}

export default RapportiNew;
